module.exports = __webpack_public_path__ + "index_assets/img/all_win_title.9b705b29.png";